import { createEffect } from "solid-js";
import { CloseButton } from "~/components/ui/close";
import { Group } from "~/components/ui/group";
import { Tabs, TabsContent } from "~/components/ui/tabs";
import { BoldText } from "~/components/ui/text";
import { useDocumentContext } from "../../../providers/context";
import { DocumentBookmarksMobile } from "../Bookmarks/mobile";
import { SearchBar } from "../SearchBar";
import { DocumentToc } from "../Toc";
import { DocumentSidebarTabs } from "./tabs";

export function DocumentMobileSidebar() {
	let scrollRef: HTMLDivElement | undefined;

	const { sheetOpen, setSheetOpen, documentTitle, scrollPosition, setScrollPosition, tab, setTab } =
		useDocumentContext();

	createEffect(() => {
		const open = sheetOpen();
		const position = scrollPosition();

		if (!scrollRef) {
			console.warn("Scroll revival failed, ref not found.");
			return;
		}

		if (!open) {
			setScrollPosition(scrollRef.scrollTop);
		} else {
			// Wait for the ref to be set before scrolling to the position.
			setTimeout(
				() =>
					scrollRef.scroll({
						top: position,
						behavior: "instant",
					}),
				0,
			);
		}
	});

	return (
		<Tabs
			value={tab()}
			onChange={setTab}
		>
			<div class="flex flex-col space-y-4 sticky top-0 left-0 right-0 bg-white z-50">
				<Group
					class="px-4 pt-4 sticky"
					align="stretch"
				>
					<BoldText class="text-2xl my-auto">{documentTitle()}</BoldText>
					<CloseButton onClick={() => setSheetOpen(false)} />
				</Group>
				<SearchBar />
				<Group class="px-4 border-b pb-4">
					<DocumentSidebarTabs />
				</Group>
			</div>
			<TabsContent
				class="mt-0"
				value="toc"
			>
				<DocumentToc screen="mobile" />
			</TabsContent>
			<TabsContent
				class="mt-0"
				value="bookmarks"
			>
				<DocumentBookmarksMobile />
			</TabsContent>
		</Tabs>
	);
}
